import React from 'react';
import classNames from 'classnames';

import { StyledCheckbox } from 'components/UI/StyledCheckbox';

type Option = {
  id: string;
  label: string;
  disabled: boolean;
};

type Props = {
  name: string;
  label: string;
  option: Option;
  selected: string | null;
  onChange: (value: 'true' | null) => void;
  className?: string;
};

export const Checkbox: React.FC<Props> = ({
  selected,
  onChange,
  label,
  option,
  name,
  className,
  children,
}) => (
  <aside className={classNames(className, 'checkbox-group')}>
    <h1 className='checkbox-group__label  lh-1 mb-1'>{label}</h1>
    <StyledCheckbox
      key={option.id}
      className='checkbox-group__option'
      name={name}
      label={option.label}
      value={option.id}
      checked={option.id === selected}
      disabled={option.disabled}
      onChange={(checked, value) => {
        onChange(checked && value ? 'true' : null);
      }}
    />
    {children}
  </aside>
);
